import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { RoleGetResponseDto } from "../dtos/role-get-response.dto";
import { RoleRegisterRequestDto } from "../dtos/role-register-request.dto";
import { RoleRegisterResponseDto } from "../dtos/role-register-response.dto";
import { BaseService } from "./base.service";

@Injectable()
export class RoleService extends BaseService {

    url: string = `${environment.Apis.accessControl}/access-control/role`;

    constructor(
        private httpClient: HttpClient,
    ) {
        super();
    }

    list(): Observable<RoleGetResponseDto[]> {
        return this.httpClient
            .get(`${this.url}`, this.authorizedHeader())
            .pipe(
                map(this.extractData),
                catchError(this.serviceError)
            );
    }

    getById(_id: string): Observable<RoleGetResponseDto> {
        return this.httpClient
            .get(`${this.url}/id/${_id}`, this.authorizedHeader())
            .pipe(
                map(this.extractData),
                catchError(this.serviceError)
            );
    }

    update(_id: string, dto: RoleRegisterRequestDto): Observable<RoleRegisterResponseDto> {
        return this.httpClient
            .put(`${this.url}/id/${_id}`, dto, this.authorizedHeader())
            .pipe(
                map(this.extractData),
                catchError(this.serviceError)
            );
    }

    register(dto: RoleRegisterRequestDto): Observable<RoleRegisterResponseDto> {
        return this.httpClient
            .post(`${this.url}`, dto, this.authorizedHeader())
            .pipe(
                map(this.extractData),
                catchError(this.serviceError)
            );
    }

    delete(_id:string): Observable<any>{
        return this.httpClient.delete(`${this.url}/id/${_id}`, this.authorizedHeader())
            .pipe(
                map(this.extractData),
                catchError(this.serviceError)
            );
    }
}